import PageLayout from '../../layouts/PageLayout'

export default function NotFoundPage() {
  return (
    <PageLayout className={'flex items-center justify-center'}>
      <h1>This is not found page</h1>
    </PageLayout>
  )
}
